import React from "react";
import { useAppSelector } from "@/hooks";

import { Box, Container, FlexDiv } from "@/components/Atoms/Box";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import { Typography } from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

import { StyledHeadSection, StyledChip, ShadowButton } from "./style";

function HeadSection({ scrollToApplySection }) {
  const { jobData } = useAppSelector((state) => state.careersPage);

  const {
    dept_name_display: team,
    role,
    location,
    type,
    apply_url: applyUrl,
  } = jobData || {};

  return (
    <StyledHeadSection>
      <Container className="container">
        <Box className="head-section">
          <Typography
            variant="label3"
            fontFamily="var(--man-800)"
            textTransform="uppercase"
            color={theme.colorsV2.primary.shade_900}
            className="careers"
            letterSpacing="0.12em"
          >
            Careers
          </Typography>
          <FlexDiv className="job-info">
            <Typography
              variant="heading2"
              fontFamily="var(--man-400)"
              className="team"
            >
              {team}
            </Typography>
            <Typography variant="heading2" className="role">
              {role}
            </Typography>
          </FlexDiv>
          <FlexDiv className="chips">
            {location && (
              <StyledChip alignItems="center">
                <StyledSvgSprite
                  icon="icon-MapPin"
                  height="16px"
                  width="16px"
                  margin="0 8px 0 0"
                />
                <Typography
                  variant="label3"
                  color={theme.colorsV2.gray.shade_700}
                >
                  {location}
                </Typography>
              </StyledChip>
            )}
            {type && (
              <StyledChip alignItems="center">
                <StyledSvgSprite
                  icon="icon-clock-2"
                  height="16px"
                  width="16px"
                  margin="0 8px 0 0"
                />
                <Typography
                  variant="label3"
                  color={theme.colorsV2.gray.shade_700}
                >
                  {type}
                </Typography>
              </StyledChip>
            )}
          </FlexDiv>
          <ShadowButton
            variant="primary1"
            bgColor={theme.colorsV2.purple.shade_700}
            hoverColor={theme.colorsV2.purple.shade_700}
            fontFamily="var(--man-700)"
            onClick={() => {
              if (applyUrl) {
                window.open(applyUrl);
              } else {
                scrollToApplySection();
              }
            }}
          >
            Apply for this Job
            {!applyUrl && (
              <StyledSvgSprite
                icon="icon-arrow-down-2"
                margin="0 0 0 10px"
                fill={theme.colors.white}
              />
            )}
          </ShadowButton>
        </Box>
      </Container>
    </StyledHeadSection>
  );
}

export default HeadSection;
